import React from "react";
import "../../styles/footer.scss";
import {
  Box,
  Button,
  Container,
  Grid,
  InputAdornment,
  InputBase,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import logo from "../../assets/logo/Footer-Logo.png";
import mainLogoNew from "../../assets/landing_page/mainLogoNew.png";
import { Link } from "react-router-dom";
import {
  FaAndroid,
  FaApple,
  FaFacebook,
  FaFacebookF,
  FaFacebookSquare,
  FaInstagram,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { RiInstagramFill } from "react-icons/ri";
import { IoLogoYoutube } from "react-icons/io5";
import Email from "../../assets/logo/email.svg";
import Phone from "../../assets/logo/phone.svg";
import Emailicon from "../../utils/icon/Email";

const Footer = () => {
  const footerItems = [
    { title: "Home", href: "/" },
    { title: "About", href: "/" },
    { title: "Contact", href: "/" },
    { title: "Support", href: "/" },
    { title: "Privacy Policy", href: "/privacy-policy" },
    { title: "Terms & Conditions", href: "/" },
  ];

  const isMobile = useMediaQuery("(min-width: 401px) and (max-width: 600px)");
  const isTablet = useMediaQuery("(min-width: 601px) and (max-width: 960px)");
  const isLaptop = useMediaQuery("(min-width: 961px) and (max-width: 1280px)");
  const isDesktop = useMediaQuery("(min-width: 1281px)");

  const MaxWidthValue = isDesktop
    ? "lg"
    : isLaptop
    ? "lg"
    : isTablet
    ? "md"
    : isMobile
    ? "sm"
    : "xs";
  return (
    <Box sx={{ paddingY: "50px" }}>
      <Container maxWidth={MaxWidthValue}>
        <section
          className="footer_wrapper pt-5"
          style={{ backgroundColor: "#F2F2F2" }}
        >
          <Container maxWidth={MaxWidthValue}>
            <Grid container spacing={5}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={5.5}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box className="mb-3">
                  <Link to="/" className="mb-3 d-flex text-center">
                    <img
                      src={mainLogoNew}
                      alt="Logo"
                      style={{ height: "76px", width: "74px" }}
                    />
                  </Link>
                  <Typography variant="subtitle1" sx={{ color: "#425262" }}>
                    PrismView Programmed To Generate Human-Like Responses And
                    Provide Information On A Wide Range Of Topics.
                  </Typography>
                </Box>
                <Grid container spacing={5}>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <Stack spacing={2} direction="column">
                      <Stack direction="row" alignItems={"center"}>
                        <img
                          src={Phone}
                          className="work-card-img"
                          alt="email"
                        />
                        <Typography variant="h4" className="title">
                          Connect On
                        </Typography>
                      </Stack>

                      <Typography variant="subtitle1" className="description">
                        703-577-2554
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Stack spacing={2} direction="column">
                      <Stack direction="row" alignItems={"center"}>
                        <img
                          src={Email}
                          className="work-card-img"
                          alt="email"
                        />
                        <Typography variant="h4" className="title">
                          Contact
                        </Typography>
                      </Stack>
                      <Typography variant="subtitle1" className="description">
                        support@prismview.ai
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Box className="">
                  <Typography
                    variant="h3"
                    className="mb-3"
                    style={{
                      color: "#036185",
                      fontWeight: "700",
                      fontSize: "18px",
                    }}
                  >
                    Quick Links
                  </Typography>
                  <Stack spacing={3} direction="row">
                    <Stack spacing={2} className="nav-items">
                      {footerItems.map((item) => (
                        <Link
                          to={item.href}
                          key={item.title}
                          style={{
                            textDecoration: "none",
                            marginTop: "10px",
                          }}
                        >
                          <Button
                            on
                            sx={{
                              px: 0,
                              color: "#425262 !important",
                              fontWeight: "400 !important",
                              fontSize: "14px !important",
                              textAlign: "left",
                              lineHeight: "16.66px !important",
                              justifyContent: "flex-start",
                            }}
                          >
                            {item.title}
                          </Button>
                        </Link>
                      ))}
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3.5}>
                <Box>
                  <Typography
                    variant="h3"
                    className="mb-3"
                    style={{
                      color: "#036185",
                      fontWeight: "700",
                      fontSize: "18px",
                    }}
                  >
                    Join Us
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    className="mb-3 title"
                    sx={{ padding: "0px !important", color: "#425262" }}
                  >
                    Get hot news and benefits delivered to your inbox
                  </Typography>
                  <Paper
                    component="form"
                    className="subscribe"
                    sx={{
                      p: "6px 0px",
                      display: "flex",
                      alignItems: "center",
                      width: 400,
                      flexDirection: "column",
                      background: "transparent",
                    }}
                  >
                    <InputBase
                      sx={{
                        px: 1,
                        flex: 1,
                        border: "1px solid #e4e4e7",
                        borderRadius: "9px",
                        width: "100%",
                        padding: "16px",
                        marginBottom: "10px",
                        "& .MuiInputBase-input::placeholder": {
                          color: "#a1a1aa", // Placeholder text color
                          fontSize: "14px", // Font size for the placeholder
                          fontWeight: "400",
                        },
                      }}
                      placeholder="Enter Your Email Address"
                      inputProps={{ "aria-label": "search google maps" }}
                      startAdornment={
                        <InputAdornment position="start">
                          <Emailicon />
                        </InputAdornment>
                      }
                    />

                    <Button
                      className="send-button"
                      color="primary"
                      sx={{
                        p: "16px",
                        background:
                          " radial-gradient(100.93% 138.49% at -0.26% 7.52%, #64BCD2 0%, #036185 100%)",
                        borderRadius: "9px",
                      }}
                      aria-label="directions"
                    >
                      Subscribe Now
                    </Button>
                  </Paper>
                </Box>
              </Grid>
            </Grid>
          </Container>
          <Container maxWidth={MaxWidthValue}>
            <Box className="copyright-wrapper mt-3 py-3">
              <Typography
                variant="caption"
                component="div"
                className="d-block text-center"
              >
                © 2024 , All Rights Reserved
              </Typography>
              <Stack spacing={2} direction="row" className="social-wrapper">
                <Box
                  sx={{
                    borderRadius: "50%", // Makes the Box circular
                    backgroundColor: "#00446b",
                    padding: "4px",
                  }}
                >
                  <FaFacebookF size={24} color="white" />
                </Box>
                <Box
                  sx={{
                    borderRadius: "50%", // Makes the Box circular
                    backgroundColor: "#00446b",
                    padding: "4px",
                  }}
                >
                  <FaInstagram size={24} color="white" />
                </Box>
                <Box
                  sx={{
                    borderRadius: "50%", // Makes the Box circular
                    backgroundColor: "#00446b",
                    padding: "4px",
                  }}
                >
                  <FaTwitter size={24} color="white" />
                </Box>
                <Box
                  sx={{
                    borderRadius: "50%", // Makes the Box circular
                    backgroundColor: "#00446b",
                    padding: "4px",
                  }}
                >
                  <FaYoutube size={24} color="white" />
                </Box>
                <Box
                  component={Link}
                  to="https://apps.apple.com/us/app/primsview-ehs/id6680179954"
                  target="_blank"
                  sx={{
                    borderRadius: "50%", // Makes the Box circular
                    backgroundColor: "#00446b",
                    padding: "4px",
                    color: "white",
                  }}
                >
                  <FaApple size={24} color="white" style={{ fill: "white" }} />
                </Box>
                <Box
                  component={Link}
                  to="https://play.google.com/store/apps/details?id=com.prismview.ehs&hl=en"
                  target="_blank"
                  sx={{
                    borderRadius: "50%", // Makes the Box circular
                    backgroundColor: "#00446b",
                    padding: "4px",
                  }}
                >
                  <FaAndroid
                    size={24}
                    color="white"
                    style={{ fill: "white" }}
                  />
                </Box>
              </Stack>
            </Box>
          </Container>
        </section>
      </Container>
    </Box>
  );
};

export default Footer;
